import { useState } from "react";
import { useSendInviteMutation } from "../redux/services/companyApi";
import { toast } from "sonner";

interface FormState {
    firstname: string;
    last_name: string;
    email: string;
}

export const useCompanySetup = () => {
    const [personalOpen, setPersonalOpen] = useState(true);
    const [form, setForm] = useState<FormState>({
        firstname: "",
        last_name: "",
        email: "",
    });

    const [sendInvite, { isLoading: sending }] = useSendInviteMutation();

    const handleFormChange = (key: keyof FormState, value: string) => {
        const updatedForm = { ...form, [key]: value };
        setForm(updatedForm);

        console.log("Updated form values:", updatedForm);
    };

    const handleNext = async (onSuccess?: () => void) => {
    if (!personalOpen) {
        // if user is not the head, send full payload
        try {
            const payload = { ...form, is_hog: false };
            console.log("Preparing to send invite with payload:", payload);

            const response = await sendInvite(payload).unwrap();
            console.log("Invite response:", response);

            localStorage.setItem("inviteDetails", JSON.stringify(form));
            toast.success("Invite sent successfully!");

            if (onSuccess) onSuccess();
        } catch (err: any) {
            console.error("Invite failed:", err);
            toast.error(err?.data?.message || "Failed to send invite");
        }
    } else {
        // user is the head of org sent only { is_hog: true }
        try {
            const payload = { is_hog: true };
            console.log("Sending HOG payload:", payload);

            await sendInvite(payload).unwrap();
            toast.success("Saved successfully!");

            if (onSuccess) onSuccess();
        } catch (err: any) {
            console.error("Head-of-office send failed:", err);
            toast.error(err?.data?.message || "Failed to save");
        }
    }
};

    return {
        personalOpen,
        setPersonalOpen,
        form,
        handleFormChange,
        handleNext,
        sending,
    };
};
